export const EMPLOYEE_WORKIN_PAGE = {
  TIME_STAMP: "time_stamp",
  CALENDAR: "calendar",
  WORKIN: "work_in",
  WORK_IN_LOCATION: "work_in_location",
  LEAVE_BENEFIT: "leave_benefit",
};

export const EMPLOYEE_WORKIN_PAGE_LIST = Object.values(EMPLOYEE_WORKIN_PAGE);
